import { Navigate } from 'react-router-dom';
import { isAuthenticated as checkAuth } from '../utils/auth';

// Redirect authenticated users away from public routes like /login
export default function PublicRoute({ children }) {
  // Simple synchronous check - if user is authenticated, redirect
  // This will catch users who are already logged in when they visit /login
  const authenticated = checkAuth();

  if (authenticated) {
    return <Navigate to="/dashboard" replace />;
  }

  return children;
}
